import styled from 'styled-components';
import { GlobalToken } from 'antd';

import EPTable from '@/comp/EPTable';

import { EngineStepsContainer } from '../Common/styled';
import { GeneralContainer } from '../../General/styled';
import { StageCard } from '@/comp/StationStages/styled';

export const CentrifugalPageContainer = styled.div`
  padding: ${({ theme: { token } }) => `${token.paddingMD}px`}; 
  flex-grow: 1;
  position: relative;
  overflow: auto;

}

  .eco-select-station {
    width: 300px;
    .ant-select{
    border:none;}
  }
`;

export const CentrifugalHeader = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};

   .header {
    display: flex;
    gap: 1rem;
    
    @media (max-width: 1024px) {
      flex-direction: column-reverse;
      gap: 1.5rem;
      align-items: stretch;

      .eco-select-station {
        width: 100%;
      }
    }
    
    ${StageCard} {
      flex: 1;
      margin: 0;
    }
  }

  .ant-tabs {
    width: 100%;



    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${({ theme: { token } }) => token.colorPrimary};
    }
  }

  .ant-tabs-nav {
    display: flex;
    margin-top: 1rem;
    justify-content: center;

    &:before {
      border: none;
    }

    .ant-tabs-nav-wrap {
      flex: none;

      &.ant-tabs-tab-active {
        color: ${({ theme: { token } }) => token.colorPrimary};
        .ant-tabs-tab-btn {
          color: ${({ theme: { token } }) => token.colorPrimary};
          .disabled {
            cursor: pointer;
            color: ${({ theme: { token } }) => token.colorText};
          }
        }
      }

      .ant-tabs-ink-bar {
        background-color: ${({ theme: { token } }) => token.colorPrimary};
        height: 3px;
        border-radius: 5px 5px 0 0;
      }
    }

    .ant-tabs-tab {
      color: ${({ theme: { token } }) => token.colorText};

     .ant-tabs-tab-btn {
        color: ${({ theme: { token } }) => token.colorText};
        .disabled {
           cursor: pointer;
           color: ${({ theme: { token } }) => token.colorBorder};
         }
      }
     }
    }
  }
`;

export const CentrifugalVersionContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-grow: 1;
  position: relative;
  overflow: hidden;

  .header {
    display: flex;
  }

  .ant-tabs {
    .ant-tabs-nav {
      justify-content: flex-start;
      border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    }
  }
  .centrifugal-tab-container {
    padding: ${({ theme: { token } }) => `${token.paddingMD}px ${token.padding}px ${token.paddingMD}px`};
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
  }

  .published-container {
    display: flex;
    justify-content: space-between;
    color: ${({ theme: { token } }) => token.colorText};
    gap: 1rem;
    align-items: center;

    .view-only {
      display: flex;
      gap: 1.5rem;
      a {
        cursor: pointer;
        :hover {
          text-decoration: underline;
        }
      }
    }
  }

  .draft-container {
    display: flex;
    justify-content: space-between;
    color: ${({ theme: { token } }) => token.colorText};
    gap: 2rem;
    align-items: center;

    .view-only {
      gap: 1.5rem;
      a {
        cursor: pointer;
        :hover {
          text-decoration: underline;
        }
      }
    }

    .actions-container {
      display: flex;
      gap: 1rem;
      align-items: center;
    }

    .draft-published-text {
      color: ${({ theme: { token } }) => token.colorPrimary};
    }
  }

  .custom-notification {
    .ant-message {
      top: unset !important;
      bottom: 20px; /* Adjust as needed */
      left: 50%;
      transform: translateX(-50%);
    }
  }

  ${EngineStepsContainer} {
    color: ${({ theme: { token } }) => token.colorText};
  }

  ${GeneralContainer} {
    display: block;
  }
`;

export const DraftActionsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;

  .ant-space-item {
    border: 1px solid;
    padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.padding}px`};
    border-radius: 5px;
  }

  .ant-dropdown-menu {
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
  }

  .ant-dropdown-menu-item:hover {
    background-color: ${({ theme: { token } }) => token.colorBgContainer};

    color: ${({ theme: { token } }) => token.colorText};
  }

  .ant-dropdown-menu-item {
    color: ${({ theme: { token } }) => token.colorText};
  }

  .more-actions {
    display: flex;
    align-items: center;
    padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.padding}px`};
    border-radius: 5px;
    border: 1px solid ${({ theme: { token } }) => token.colorBorder};
  }

  .save-button {
    &.ant-btn-primary {
      height: auto;
      min-width: 100px;
    }
  }

  .confirmation-notification {
    .ant-notification-notice-content {
      .ant-notification-notice-with-icon {
        .ant-notification-notice-message {
          color: ${({ theme: { token } }) => token.colorError} !important;
        }
      }
    }

    .ant-notification-notice {
      background-color: ${({ theme: { token } }) => token.colorError};
      border-radius: 20px;
      width: 500px;
    }
  }
`;

export const StyledDrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme: { token } }) => `${token.padding}px`};
  justify-content: center;
  gap: 16px;
  width: 100%;
`;
interface StationParametersContainerProps {
  $activeTab: string;
  theme: {
    token: GlobalToken;
  };
}

export const StationParametersContainer = styled.div<StationParametersContainerProps>`
  .advanced-title {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: ${({ theme: { token } }) => token.colorText};
    padding: ${({ theme: { token } }) => `${token.padding}px`};
  }

  .error {
    color: ${({ theme: { token } }) => token.colorError};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    border: 1px solid ${({ theme: { token } }) => token.colorError};
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-content {
    color: ${({ theme: { token } }) => token.colorText};
    .ant-collapse-content-box {
      padding: 0;
      margin-left: ${({ theme: { token } }) => token.marginXL}px;
      overflow-y: visible;
    }
  }

  .ant-table-cell.ant-table-cell-row-hover.custom:hover {
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    color: ${({ theme: { token } }) => token.colorText};
  }

  .ant-form {
    width: 50%;

    .ant-table-thead {
      .ant-table-cell {
        color: ${({ theme: { token } }) => token.colorText};
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }
    }

    .ant-table-thead > tr > th {
      &:before {
        border: none !important;
        background-color: transparent !important;
      }
    }

    .ant-table-tbody {
      .ant-table-cell {
        color: ${({ theme: { token } }) => token.colorText};

        .ant-form-item {
          .ant-row {
            width: 6rem;
          }

          .ant-form-item-control-input {
            .ant-form-item-control-input-content {
              input {
                background-color: ${({ theme: { token } }) => token.colorBgElevated};
                color: ${({ theme: { token } }) => token.colorText};
                border-radius: 5px;
              }
              span {
                background-color: ${({ theme: { token } }) => token.colorBgElevated};
                color: ${({ theme: { token } }) => token.colorText};
                border-radius: 5px;
              }
            }
          }
        }
      }
    }
  }

  ${props =>
    props.$activeTab === 'published' &&
    `
      .ant-table-content {
      pointer-events: none;
      .ant-table-thead {
        th {
          &:before {
            background-color: transparent;
          }
        }
      }

      .ant-table-tbody {
        tr {
          td {
            .ant-form-item {
              .ant-row {
                width:  6rem;
              }

              .ant-form-item-control-input {
                .ant-form-item-control-input-content {
                  input {
                    border: none;
                  }
                  span {
                    border: none;
                  }
                }
              }
            }
          }
        }
      }

      overflow: auto;
    }
  `}

  ${props =>
    props.$activeTab === 'draft' &&
    `
      .ant-table-content {
      .ant-table-thead {
        th {
          &:before {
            background-color: transparent;
          }
        }
      }

      .ant-table-tbody {
        tr {
          td {
            .ant-form-item {
              .ant-row {
                width:  10rem;
              }

              
            }
          }
        }
      }

    }
  `}
`;

export const CompressorParametersContainer = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: ${({ theme: { token } }) => token.colorText};
    padding: 0;
    margin-top: ${({ theme: { token } }) => token.margin}px;
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
  }

  .error-text {
    border: 1px solid ${({ theme: { token } }) => token.colorText};
    border-radius: 2px;
    background-color: ${({ theme: { token } }) => token.colorErrorBorder};
  }

  .unit-measurement-header {
    margin-bottom: 16px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }
`;

export const StyledTableContainer = styled(EPTable)<{ theme: { token: GlobalToken } }>`
  .ant-table {
    .ant-table-thead {
      .ant-table-cell {
        background-color: ${({ theme: { token } }) => token.colorBgContainer};
        color: ${({ theme: { token } }) => token.colorText};
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }
    }
    .ant-table-content {
      background-color: ${({ theme: { token } }) => token.colorBgContainer};
    }

    .ant-table-tbody > tr {
      > td {
        input {
          color: ${({ theme: { token } }) => token.colorText};
          font-size: ${({ theme: { token } }) => token.fontSize}px;
          width: 6rem;
        }
        span {
          color: ${({ theme: { token } }) => token.colorText};
        }

        .ant-input-affix-wrapper {
          width: 6rem;
        }

        /* Specific styling for Max Flow column to accommodate longer decimal values */
        &:nth-child(7) {
          input {
            width: calc(${({ theme: { token } }) => token.controlHeightLG}px * 2);
          }
          .ant-input-affix-wrapper {
            width: calc(${({ theme: { token } }) => token.controlHeightLG}px * 3);
          }
        }
      }
    }
  }
`;

export const StyledTabsContainer = styled.div`
  .ant-tabs {
    position: relative;
  }

  .ant-tabs-nav {
    position: relative;
    display: flex;
    justify-content: center;
  }

  .ant-tabs-nav-wrap {
    flex: unset;
    justify-content: center;
  }

  .ant-tabs-nav-list {
    position: relative;
    display: flex;
  }

  .ant-tabs-extra-content {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  ${StageCard} {
    margin: 0 0 1rem 0;
  }
`;
